export default "__VITE_ASSET__DTfvs5go__"